import {useI18n} from '@yandex-delivery/core/i18n'
import {Controller, Input, useFormContext} from '@yandex-delivery/form'
import React from 'react'

import type {EmailInputProps} from './EmailInput.types'

export function EmailInput({name, 'data-testid': dataTestId}: EmailInputProps): React.ReactElement {
  const {control} = useFormContext()
  const t = useI18n()

  return (
    <Controller
      control={control}
      name={name}
      render={({field, fieldState}) => {
        return (
          <div ref={field.ref}>
            <Input
              data-testid={dataTestId}
              error={fieldState.invalid}
              helperText={fieldState.error?.message}
              label={t('cargo.create.contact.email', 'Почта')}
              name={name}
              onBlur={field.onBlur}
              onChange={field.onChange}
              size="l"
              type="email"
              value={field.value}
              variant="line"
            />
          </div>
        )
      }}
    />
  )
}
